export default (
  state = { isLoading: false, services: [], products: [], subcategories: [], categories: [] },
  action
) => {
  const restrictProducts = process.env.REACT_APP_RESTRICT_PRODUCTS ? process.env.REACT_APP_RESTRICT_PRODUCTS.split(',') : []
  const checker = (value) => {
    for (var i = 0; i < restrictProducts.length; i++) {
      if (value.indexOf(restrictProducts[i]) > -1) {
        return false
      }
    }
    return true
  }

  switch (action.type) {
    case 'FETCH_SEARCH':
      return { ...state, isLoading: true }
    case 'FETCH_SEARCH_SUCCESS':
      const subcategories = action.payload.data.subcategories
      let products = action.payload.data.products

      if (restrictProducts.length) {
        products = products.filter(el => checker(el.name.toLowerCase()))
      }

      return {
        ...state,
        isLoading: false,
        services: action.payload.data.services,
        products: products,
        subcategories: action.payload.data.subcategories.slice(
          0,
          subcategories.length > 5 ? 5 : subcategories.length
        ),
        categories: action.payload.data.categories
      }
    case 'FETCH_SEARCH_FAIL':
      return { ...state, isLoading: false, error: action.error }
    case 'EMPTY_SEARCH':
      return {
        ...state,
        isLoading: false,
        services: [],
        products: [],
        subcategories: [],
        categories: []
      }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/App/Header/Search/reducer.js